import { Component, OnInit, OnDestroy } from '@angular/core';
import { BankAcc } from '../../../../models/BankAcc';
import { Code } from '../../../../models/Code';

import { AdminService } from '../../../../services/Admin.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ConfirmationPageFailComponent } from '../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
/*tslint:disable:max-line-length */
import { ConfirmationPageSuccessComponent } from '../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusyIndicatorComponent } from '../../../../shared-components/busy-indicator/busy-indicator.component';
import { DataService } from '../../../../services/data.service';
import { LoginResult } from '../../../../models/LoginResult';

@Component({
  selector: 'app-bank-account-v',
  templateUrl: './bank-account-v.component.html',
  styleUrls: ['./bank-account-v.component.scss']
})
export class BankAccountVComponent implements OnInit, OnDestroy {

  public bankAccModel: BankAcc = new BankAcc();
  public countryList: Code[];
  public  accountTypeList: Code[];
  public errorMsg: string;
  public successMsg: string;
  private currentYear: number;
  private index: number;
  private _router: Router;
  private userInfo: LoginResult;
  showFailConfirmation: boolean;
  showSuccessConfirmation: boolean;
  isAccountExists = false;
  private alive = true;

  constructor(private adminSvc: AdminService,
     private router: Router,
    private spinner: NgxSpinnerService,
    private dataSvc: DataService) {
      this._router = router;
      this.userInfo = dataSvc.userDisplayInfo;
    }

  ngOnInit() {
    this.getaccountTypes();
    this.getCountries();
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  getCountries() {
    this.adminSvc.getCountries()
    .takeWhile(() => this.alive)
    .subscribe(data => {
      this.countryList = data;
    });
  }

  getaccountTypes() {
    this.adminSvc.getBankAccountTypes()
    .takeWhile(() => this.alive)
    .subscribe(data => {
      this.accountTypeList = data;
    });
  }

  checkAccountExists(frmAddBA: NgForm) {
    if (this.bankAccModel.AccountNumber && this.bankAccModel.AccountNumber !== '' && this.bankAccModel.BankName && this.bankAccModel.BankName !== '') {
        this.adminSvc.isVendorBankAccountExists(this.bankAccModel.BankName, this.bankAccModel.AccountNumber, this.userInfo.GPVID)
        .takeWhile(() => this.alive)
        .subscribe(
          data => {
                    if (data === true) {
                      this.isAccountExists = true;
                      frmAddBA.controls['bankAccModel.AccountNumber'].setErrors({'incorrect' : true});
                    } else {
                      this.isAccountExists = false;
                      frmAddBA.controls['bankAccModel.AccountNumber'].setErrors(null);
                    }
                },
          err => {
              this.successMsg = null;
              this.errorMsg = err;
              this.showFailConfirmation = true;
              this.showSuccessConfirmation = false;
          }
        );
    }
  }

  onCancel() {
    this._router.navigate(['/pages/vendor/myvendor/home']);
  }

  onSubmit(frmAddBA: NgForm) {
    this.errorMsg = null;
    this.successMsg = null;
    this.spinner.show();
       this.adminSvc.saveVedorBankAccount(this.bankAccModel)
       .takeWhile(() => this.alive)
       .subscribe(
      data => {
                if (data === true) {
                  this.successMsg = 'Bank account added successfully.';
                  this.errorMsg = null;
                  this.bankAccModel = new BankAcc();
                  this.showFailConfirmation = false;
                  this.showSuccessConfirmation = true;
                  this.spinner.hide();
                } else {
                  this.successMsg = null;
                  this.errorMsg = 'Failed to add Bank account.';
                  this.showFailConfirmation = true;
                  this.showSuccessConfirmation = false;
                  this.spinner.hide();
                }
            },
      err => {
          this.successMsg = null;
          this.errorMsg = err;
          this.showFailConfirmation = true;
          this.showSuccessConfirmation = false;
          this.spinner.hide();
        }
    );
   // window.scrollTo(0, 0);
  }

  goToMyVendor(event) {
    this._router.navigate(['/pages/vendor/myvendor/home']);
  }

  close(event) {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  public ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-settings-v/bank-account-v/bank-account-v.component.ts